var map = {
	"./ace_of_swords.png": 973,
	"./eight_of_swords.png": 974,
	"./five_of_swords.png": 975,
	"./four_of_swords.png": 976,
	"./king_of_swords.png": 977,
	"./knight_of_swords.png": 978,
	"./nine_of_swords.png": 979,
	"./page_of_swords.png": 980,
	"./queen_of_swords.png": 981,
	"./seven_of_swords.png": 982,
	"./six_of_swords.png": 983,
	"./ten_of_swords.png": 984,
	"./three_of_swords.png": 985,
	"./two_of_swords.png": 986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 972;